import type {Electricity, ElectricityResponse} from '@domain/electricity'
import {mapLoadCurvesResToElectricityData} from '@domain/electricity'
import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'
import {Moment} from 'moment-timezone'
import {useCallback} from 'react'

export type MomentRange = [start: Moment, end: Moment]

export const ELECTRICITY_QUERY_KEY = 'electricity'

interface UseElectricityQueryParams {
  plantId: string
  timezoneId: string
  timeFrame: MomentRange
  throwOnError?: boolean
}

export const useElectricityQuery = ({
  plantId,
  timezoneId,
  timeFrame: [start, end],
  throwOnError = true
}: UseElectricityQueryParams) => {
  return useQuery<ElectricityResponse, unknown, Electricity>({
    queryKey: [
      ELECTRICITY_QUERY_KEY,
      {plantCode: plantId, start: start.toISOString(), end: end.toISOString()}
    ],
    queryFn: async ({signal}) => {
      const path = '/schedules/current/load-curves'
      const {data} = await ApiClient.axiosInstance.get<ElectricityResponse>(path, {
        params: {plantCode: plantId, start: start.toISOString(), end: end.toISOString()},
        signal
      })
      return data
    },
    select: useCallback(
      (data: ElectricityResponse) => mapLoadCurvesResToElectricityData(data, timezoneId),
      [timezoneId]
    ),
    throwOnError
  })
}
